export function getEventSource() {
    return typeof EventSource === 'function' ? EventSource : undefined;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio/es/platform/getEventSource/browser.js
// module id = 3947
// module chunks = 25